export default function WhatsAppDiagnostic() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/33745883392?text=Bonjour,%20je%20souhaite%20un%20diagnostic%20vidéo%20pour%20ma%20fenêtre', '_blank');
  };

  return (
    <section id="whatsapp-diagnostic" className="py-16 lg:py-20 bg-gradient-to-br from-teal-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          {/* Contenu gauche */}
          <div className="space-y-6 lg:space-y-8">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-video-line text-lg"></i>
              <span>Nouveau Service</span>
            </div>

            <div className="space-y-4">
              <h2 className="text-3xl lg:text-5xl font-bold text-gray-900">
                Diagnostic Vidéo
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-orange-500 mt-2">
                  via WhatsApp
                </span>
              </h2>
              <p className="text-lg lg:text-xl text-gray-600">
                Gagnez du temps ! Obtenez un pré-diagnostic instantané et un <a href="#contact" className="text-teal-600 hover:text-teal-700 underline font-medium">devis estimatif</a> en quelques minutes grâce à notre service de visio-diagnostic.
              </p>
            </div>

            {/* Avantages */}
            <div className="space-y-4">
              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Réponse en 15 minutes</h3>
                  <p className="text-gray-600 text-sm">Notre expert vous répond rapidement et analyse votre problème en direct</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex-shrink-0">
                  <i className="ri-smartphone-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Simple et rapide</h3>
                  <p className="text-gray-600 text-sm">Filmez votre fenêtre, envoyez la vidéo, recevez votre diagnostic</p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex-shrink-0">
                  <i className="ri-money-euro-circle-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Devis estimatif gratuit</h3>
                  <p className="text-gray-600 text-sm">Obtenez une estimation tarifaire avant même notre déplacement. Voir notre <a href="/blog/prix-reparation-fenetre-lyon-2025" className="text-teal-600 hover:text-teal-700 underline">guide des prix</a></p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">Conseils d'expert</h3>
                  <p className="text-gray-600 text-sm">Bénéficiez de recommandations personnalisées pour votre situation</p>
                </div>
              </div>
            </div>

            {/* CTA WhatsApp */}
            <div className="space-y-4">
              <button
                onClick={handleWhatsAppClick}
                className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-3xl"></i>
                <span>Démarrer le diagnostic vidéo</span>
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </button>
              <p className="text-sm text-gray-500 flex items-center gap-2">
                <i className="ri-lock-line"></i>
                <span>Vos données sont sécurisées et confidentielles</span>
              </p>
            </div>

            {/* Instructions */}
            <div className="bg-gradient-to-r from-teal-500/10 to-orange-500/10 border-l-4 border-teal-500 p-4 rounded-lg">
              <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-information-line text-teal-500"></i>
                Comment ça marche ?
              </h4>
              <ol className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="font-bold text-teal-500">1.</span>
                  <span>Cliquez sur le bouton WhatsApp ci-dessus</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold text-teal-500">2.</span>
                  <span>Filmez votre fenêtre (problème, mécanisme, vitrage)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold text-teal-500">3.</span>
                  <span>Envoyez la vidéo à notre expert</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-bold text-teal-500">4.</span>
                  <span>Recevez votre diagnostic et devis estimatif</span>
                </li>
              </ol>
            </div>
          </div>

          {/* Image droite */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7e10d79c3412515c41310069b2fe920e.jpg"
                alt="Diagnostic vidéo via WhatsApp"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>

            {/* Badge flottant */}
            <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4 transform rotate-3 hover:rotate-0 transition-transform">
              <div className="flex items-center gap-3">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 rounded-xl">
                  <i className="ri-whatsapp-line text-3xl text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Disponible</div>
                  <div className="text-sm text-gray-600">7j/7</div>
                </div>
              </div>
            </div>

            {/* Stats flottantes */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg">
                  <i className="ri-user-smile-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-2xl text-gray-900">500+</div>
                  <div className="text-sm text-gray-600">Diagnostics réalisés</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Témoignage */}
        <div className="mt-12 lg:mt-16 bg-white rounded-2xl shadow-lg p-6 lg:p-8 max-w-3xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex-shrink-0 text-white text-2xl font-bold">
              MC
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400"></i>
                  ))}
                </div>
                <span className="text-sm text-gray-500">Il y a 2 jours</span>
              </div>
              <p className="text-gray-700 italic mb-3">
                "Service incroyable ! J'ai envoyé une vidéo de ma fenêtre bloquée via WhatsApp et j'ai reçu un diagnostic complet en 10 minutes. Le technicien m'a expliqué le problème et donné un devis précis. Intervention réalisée le lendemain. Je recommande !"
              </p>
              <div className="font-semibold text-gray-900">Marie C.</div>
              <div className="text-sm text-gray-600">Lyon 6ème</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
